import StatusProcessing from './Status';

export default class Processing {
    constructor(public Status: string, public Percent: number) {

    }
}